import type { FunctionComponent } from 'react';
import { Box, xcss } from '@atlaskit/primitives';

import { defineMessages, FormattedMessage } from 'react-intl';

const centeredContentStyles = xcss({
  textAlign: 'center',
});

const messages = defineMessages({
  description: {
    id: 'applinks.description',
    defaultMessage:
      'The application {appName} would like to have read and write access to your data on {url}. The application will be allowed to use your credentials to authenticate as you ({userFullName}) in the future.',
    description:
      'Description for applinks describing that the app (Jira or Confluence) would like to have permissions to read and write on behalf of the user on the provided site',
  },
});

type DescriptionProps = {
  appName: string;
  url: string;
  userFullName: string;
};

const Description: FunctionComponent<DescriptionProps> = ({
  appName,
  url,
  userFullName,
}) => (
  <Box xcss={centeredContentStyles}>
    <FormattedMessage
      {...messages.description}
      values={{
        appName: <strong>{appName}</strong>,
        url: <strong>{url}</strong>,
        userFullName: <strong>{userFullName}</strong>,
      }}
    />
  </Box>
);

export default Description;
